import dataService from './data-service';

export default class API {
  constructor() {}

  loginAdmin() {
    return dataService.post('/login-admin/');
  }

  login(data) {
    return dataService.post('/login/', data);
  }

  logout() {
    return dataService.post('/logout/');
  }

  getLocalization() {
    return dataService.get('/localization/');
  }

  getToken() {
    return dataService.get('/token/');
  }

  getCountries() {
    return dataService.get('/countries/');
  }

  changePassword(data) {
    return dataService.post('/change-password/', data);
  }

  forgotPassword(data) {
    return dataService.post('/forgot-password/', data);
  }

  registerPassword(data) {
    return dataService.post('/register-password/', data);
  }

  // USER ->
  addUser(data) {
    return dataService.post('/users/', data);
  }

  updateUser(id, data) {
    return dataService.put(`/users/${id}/`, data);
  }

  deleteUser(id) {
    return dataService.delete(`/users/${id}/`);
  }

  getUser(id) {
    return dataService.get(`/users/${id}/`);
  }

  getCurrentUser() {
    return dataService.get('/users/current/');
  }

  getUsers(params) {
    return dataService.get('/users/', params);
  }

  // <- USER

  // COMPANY -->

  addCompany(data) {
    return dataService.post('/companies/', data);
  }

  updateCompany(id, data) {
    return dataService.put(`/companies/${id}/`, data);
  }

  deleteCompany(id) {
    return dataService.delete(`/companies/${id}/`);
  }

  getCompany(id) {
    return dataService.get(`/companies/${id}/`);
  }

  /**
   * Get companies by params
   *
   * @param {Object} params - params object
   * @param {string} params.childrenOf - uuid string
   * @return {Promise}
   */
  getCompanies(params) {
    return dataService.get('/companies/', params);
  }

  // <- COMPANY

  // CUSTOMER MACHINES ->

  /**
   * Get customer machines by params
   *
   * @param {Object} params - params object
   * @param {string} params.company - company id
   * @param {boolean} params.includeChildCompanies - include customer machines of child companies also (only importers have child companies)
   * @return {Promise}
   */
  getCustomerMachines(params) {
    return dataService.get('/customer-machines/', params);
  }

  getCustomerMachine(serialNumber) {
    return dataService.get(`/customer-machines/${serialNumber}/`);
  }

  updateCustomerMachineOwner(serialNumber, data) {
    return dataService.put(`/customer-machines/${serialNumber}/`, data);
  }

  saveCustomerMachineInformation(serialNumber, data) {
    return dataService.put(`/customer-machines/${serialNumber}/info/`, data);
  }

  getCustomerMachineDetails(serialNumber) {
    return dataService.get(`/customer-machines/${serialNumber}/details/`);
  }

  // <- CUSTOMER MACHINES

  // COMPLAINTS ->
  addComplaint(data) {
    return dataService.post('/complaints/', data);
  }

  addComplaintFile(complaintUuid, data, config) {
    const params = {
      fileName: data.fileName
    }

    const formData = new FormData();
    formData.append('file', data.file);

    const axiosConf = {
      onUploadProgress: config && config.onProgress || null
    };

    return dataService.post(`/complaint-file/${complaintUuid}/`, formData, params, axiosConf);
  }

  /**
   * Get customer machines by params
   *
   * @param {Object} [params] - params object, if left out get all for user company
   * @return {Promise}
   */
  getComplaints(params = null) {
    return dataService.get('/complaints/', params);
  }

  getComplaint(uuid) {
    return dataService.get(`/complaints/${uuid}/`);
  }

  // <- COMPLAINTS

  // WARRANTY REGISTRATIONS ->

  addWarrantyRegistration(data) {
    return dataService.post('/warranty-registrations/', data);
  }

  /**
   * Get warranty registrations by params
   *
   * @param {Object} [params] - params object, if left out get all for user company
   * @return {Promise}
   */
  getWarrantyRegistrations(params = null) {
    return dataService.get('/warranty-registrations/', params);
  }

  getWarrantyRegistration(uuid) {
    return dataService.get(`/warranty-registrations/${uuid}/`);
  }
  // <- WARRANTY REGISTRATION
}
